export default[
    {
        name: 'AllNote',
        path: 'AllNote',
        component: () => import('@/pages/BigData/NoticeCenter/AllNote'),
        meta: { title: '全部文书' },
        props(route) {
            return {
                id: route.query.id,
            }
        },
    },
    {
        name: 'Patentnotedoc',
        path: 'Patentnotedoc',
        component: () => import('@/pages/BigData/NoticeCenter/Patentnotedoc'),
        meta: { title: '专利通知文书' },
        props(route) {
            return {
                id: route.query.id,
            }
        },
    },
    {
        name: 'Trademarknotedoc',
        path: 'Trademarknotedoc',
        component: () => import('@/pages/BigData/NoticeCenter/Trademarknotedoc'),
        meta: { title: '商标通知文书' },
        props(route) {
            return {
                id: route.query.id,

            }
        },
    },
    {
        name: 'Copyrightnotedoc',
        path: 'Copyrightnotedoc',
        component: () => import('@/pages/BigData/NoticeCenter/Copyrightnotedoc'),
        meta: { title: '版权通知文书' },
        props(route) {
            return {
                id: route.query.id,

            }
        },
    },
]
